import './search.scss';
import React, { useEffect, useState } from 'react';
import { getSearchFilter } from '../../shared/services/search/search-service';
import { Link, useHistory } from 'react-router-dom';
import { useInput } from '../../components/custom-hooks/input-hook';
import TextField from '@material-ui/core/TextField';
import SearchFilter from './search-filter';
import ImageGenerator from '../../components/image-generator/image-generator';
import Loading from '../../components/loading/item-loading/loading';

const SETTING_FILTER_SEARCH = {
	q: '',
	types: 'all',
	page: 0,
	size: 30,
	fromYear: '',
	toYear: '',
	fromImdb: 1,
	toImdb: 10,
	isDubbed: false,
	hasSubtitle: false,
	tags: ''
};

function SearchPage ({ props, onClose }) {
	const [searchDetails, setSearchDetails]        = useState([]);
	const { bind: bindSearch, reset: resetSearch } = useInput(props?.match?.params?.text);
	const [contentLoad, setContentLoad]            = useState(false);
	const history                                  = useHistory();
	const [showSetting, setShowSetting]            = useState(false);
	const [isExecuted, setIsExecuted]              = useState(false);
	const [settingFilter, setSettingFilter]        = useState(SETTING_FILTER_SEARCH);

	useEffect(() => {
		if (!props?.match?.params?.text) {
			getSearchDataFilter(SETTING_FILTER_SEARCH);
		}
	}, []);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [isExecuted, contentLoad, settingFilter]);

	const infiniteSearchDataFilter = (filterAllItems) => {
		setShowSetting(false);
		getSearchFilter(filterAllItems).then(
			(res) => {

				if (res.status === 200 && res.data.code === 200) {
					setSearchDetails((prevSearchDetails) => [...prevSearchDetails, ...res.data.data]);
					setTimeout(() => {
						setIsExecuted(false);
					}, 2000)
				}
			},
		);
	};

	const handleScroll = () => {
		const offsetHeight = document.documentElement.offsetHeight;
		const scrollTop = document.documentElement.scrollTop;
		if (window.innerHeight + scrollTop !== offsetHeight || isExecuted || !contentLoad || searchDetails.length < settingFilter.size) {
			return;
		}
		setIsExecuted(true);
		setSettingFilter((prevFilter) => ({
			...prevFilter,
			page: settingFilter.page + 1
		}));

		infiniteSearchDataFilter({
			...settingFilter,
			page: settingFilter.page + 1
		});


	};

	useEffect(() => {
	}, [searchDetails]);

	useEffect(() => {
		const text = props?.match?.params?.text
		if (text) {
			const updateSetting = JSON.parse(JSON.stringify(SETTING_FILTER_SEARCH));
			setSettingFilter((prevFilter) => ({
				...prevFilter,
				q: text
			}));
			updateSetting.q = text;
			getSearchDataFilter(updateSetting);
		}
	}, [props]);

	const [searchElement, setSearchElement] = useState();

	const checkActions = (action) => {
		if (action.value) {
			setSettingFilter(action.value);
			getSearchDataFilter(action.value)
		} else {
			setShowSetting(action.showSetting)
		}
	}
	const getSearchDataFilter = (filterAllItems) => {
		setContentLoad(false);
		setShowSetting(false);
		getSearchFilter(filterAllItems).then(
			(res) => {
				if (res.status === 200 && res.data.code === 200) {
					setSearchDetails(res.data.data);
					setContentLoad(true);
				}
			},
		);
	};



	const searchBox = () => {
		const changeInput = (e) => {
			e.preventDefault();
			clearTimeout(searchElement);
			setSearchElement(
				setTimeout(() => {
					const updateSetting = JSON.parse(JSON.stringify(SETTING_FILTER_SEARCH));
					updateSetting.q = e.target.value
					getSearchDataFilter(updateSetting);
				}, 1000)
			);
		};

		const handleSubmit = (e) => {
			e.preventDefault();
			// history.push(`/search/${bindSearch.value}`);
		};

		return (
			<div className="search-input-box">
				<form autoComplete="off"
					  onSubmit={(e) => handleSubmit(e)}
					  onChange={(e) => changeInput(e)}>
					<TextField {...bindSearch}
							   fullWidth={true}
							   placeholder={'جستجو کنید'}
							   color={'primary'}
							   variant={'outlined'}/>
				</form>
			</div>
		);
	};

	const checkMovieOrSeries = (value)=> {
		if (value === 'MOVIE') {return 'movies'; }
		return 'series';
	}

	const handleClose = () => {
		if (onClose) {
			onClose();
		}
	};

	const showResult = () => {
		if (!contentLoad) {
			return <Loading/>;
		}
		return (
			<>
				{searchDetails.length > 0 ? <div className={`result-search${showSetting ? ' hide' : ''}`}>
					{searchDetails.map((content, index) => {
						return (
							<Link key={index}
								  onClick={handleClose}
								  to={`/${checkMovieOrSeries(content.type)}/${content.id}`}
								  className="box-item">
								<ImageGenerator src={content.image}
												name={content.title} />
								<span className="box-title">{content.title}</span>
							</Link>
						);
					})}
				</div> : <p style={{textAlign: 'center'}}>متاسفانه موردی یافت نشد!</p>
				}
			</>
		)
	};

	return (
		<section className="search-container container">
			<div className='d-flex' style={{ gap: '10px', padding: '24px' }}>
				{searchBox()}
				<SearchFilter props={bindSearch.value} onChange={checkActions}></SearchFilter>
			</div>
			{showResult()}
		</section>
	);
}

export default SearchPage;
